export default __webpack_public_path__ + "static/media/followone_cat_feature_auto.7bb33199.jpg";